// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 962 ? "home" : chunkId) + "." + {"488":"00f37a4e","962":"4fd6f04c"}[chunkId] + ".chunk.js";
};